import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import ProjectList from './Project/List';
import ProjectCreate from './Project/Create';
import ProjectDetail from './Project/Detail';
import { paymentPeriods, calculationPeriods } from '../../../shared/lookup';
import { injectIntl } from "react-intl";

const defaultFields = {
    Subject: { visible: false, label: '', required: false },
    ItqRelation: { visible: false, label: '', required: false },
    ProjectRelation: { visible: false, label: '', required: false },
    ProjectOrderNumber: { visible: false, label: '', required: false },
    PurchaseOrderValue: { visible: false, label: '', required: false },
    Description: { visible: false, label: '', required: false },
    Comments: { visible: false, label: '', required: false },
    ItemsList: { visible: false, label: '', required: false },
    TotalListPrice: { visible: false, label: '', required: false },
    CompensationDescription: { visible: false, label: '', required: false },
    TotalAssessed: { visible: false, label: '', required: false },
    TotalPrice: { visible: false, label: '', required: false },
    StartDate: { visible: false, label: '', required: false },
    CompletionDate: { visible: false, label: '', required: false },
    DelayAmount: { visible: false, label: '', required: false },
    DelayPaymentPeriod: { visible: false, label: '', required: false },
    BonusRate: { visible: false, label: '', required: false },
    BonusCalculationPeriod: { visible: false, label: '', required: false },
    Type: { visible: false, label: '', required: false }
}


///ALL FIELDS ARE DECIDED WITHIN THE getFields FUNCTION
///THE getFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign fields to workflowItem
export const getFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid, globalResources, contract) => {
    const fields = { ...defaultFields };

    fields.Subject = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.SUBJECT"], required: true };
    if (contract.ispackaged) {
        fields.ProjectRelation = { visible: true, label: resources.ProjectRelationLabel, required: true };
        fields.ProjectOrderNumber = { visible: true, label: resources.ProjectOrderNumberLabel, required: true };
        fields.PurchaseOrderValue = { visible: true, label: resources.PurchaseOrderValueLabel, required: true };
    }
    if (resources.DescriptionLabel) {
        fields.Description = { visible: true, label: resources.DescriptionLabel, required: true };
    }
    if (resources.ItemsListLabel) {
        fields.ItemsList = { visible: true, label: resources.ItemsListLabel, required: true };
    }
    if (resources.TotalListPriceLabel) {
        fields.TotalListPrice = { visible: true, label: resources.TotalListPriceLabel, required: true };
    }
    if (resources.CompensationDescriptionLabel) {
        fields.CompensationDescription = { visible: true, label: resources.CompensationDescriptionLabel, required: true };
    }
    if (resources.TotalAssessedLabel) {
        fields.TotalAssessed = { visible: true, label: resources.TotalAssessedLabel, required: true };
    }
    if (resources.TotalPriceLabel) {
        fields.TotalPrice = { visible: true, label: resources.TotalPriceLabel, required: true };
    }
    if (resources.StartDateLabel) {
        fields.StartDate = { visible: true, label: resources.StartDateLabel, required: true };
    }
    if (resources.CompletionDateLabel) {
        fields.CompletionDate = { visible: true, label: resources.CompletionDateLabel, required: true };
    }
    if (resources.DelayAmountLabel) {
        fields.DelayAmount = { visible: true, label: resources.DelayAmountLabel, required: true };
    }
    if (resources.DelayPaymentPeriodLabel) {
        fields.DelayPaymentPeriod = { visible: true, label: resources.DelayPaymentPeriodLabel, required: true };
    }

    if (placeholdersQA.Fields) {
        placeholdersQA.Fields.values.forEach(fieldItem => {
            const field = fields[fieldItem.field];
            if (field) {
                field.visible = fieldItem.isActive;
                field.label = fieldItem.display;
                field.required = fieldItem.isActive;
            }
        });
    }

    if (placeholdersQA.ITQRelationEnabled) {
        const itqEnabled = placeholdersQA.ITQRelationEnabled?.values
            .find(phItem => phItem.field === 'ITQRelationEnabled').isActive;
        const itqRequired = placeholdersQA.ITQRelationRequired?.values
            .find(phItem => phItem.field === 'ITQRelationRequired').isActive;
        fields.ItqRelation = {
            visible: itqEnabled,
            label: (workflowsQA['73'] || {}).notificationName + ' ID',
            required: itqRequired
        };
    }
    
    if (!contract.ispackaged) {
        fields.ProjectRelation = { visible: false, label: resources.ProjectRelationLabel, required: false };
        fields.ProjectOrderNumber = { visible: false, label: resources.ProjectOrderNumberLabel, required: false };
        fields.PurchaseOrderValue = { visible: false, label: resources.PurchaseOrderValueLabel, required: false };
    }

    const workflowItem = workflowsQA[wfid];
    let clauses = workflowItem.clauses;

    fields.Type.clauses = clauses;
    
    return fields;
}

class ProjectPmRouter extends React.Component {
    constructor(props) {
        super(props);

        this.documentType = 'DocumentPmProject';
        this.notifyingParty = props.workflowItem.notifyingParty;

        this.notificationName = props.workflowItem.notificationName;
        this.abbreviation = props.workflowItem.abbreviation;



        this.CENProjectOrderOptionEnabled = false;
        if (this.props.workflowsQA['103']) {
            try {
                this.CENProjectOrderOptionEnabled = (this.props.workflowsQA['103'].placeholders.find(ph => ph.replacementKey === 'ProjectOrderOptionEnabled')
                    .values.find(phItem => phItem.field === 'ProjectOrderOptionEnabled').isActive);
            } catch (error) {
                console.log('ProjectOrderOptionEnabled placeholder not available!');
                this.CENProjectOrderOptionEnabled = false;
            }
        }


        this.itqNotificationName = (this.props.workflowsQA['73'] || {}).notificationName;
        this.poNotificationName = (this.props.workflowsQA['72'] || {}).notificationName;

        this.projectOrderCertifiedStartDateFieldName = null;

        if (props.resources.CertifiedStartDateLabel) {
            this.projectOrderCertifiedStartDateFieldName = props.resources.CertifiedStartDateLabel;
        }
        else if (this.props.workflowsQA['117']) {
            try {
                this.projectOrderCertifiedDateField = this.props.workflowsQA['117'].placeholders.find(ph => ph.replacementKey === 'ProjectOrderStartFields')
                    .values.find(phItem => phItem.field === 'CertifiedDate');

                if (this.projectOrderCertifiedDateField?.isActive) {
                    this.projectOrderCertifiedStartDateFieldName = this.projectOrderCertifiedDateField.display;
                }
            } catch (error) {
                console.log('ProjectOrderStartFields placeholder not available!');
            }
        }

        this.projectOrderCertifiedCompletionDateFieldName = null;

        if (props.resources.CertifiedCompletionDateLabel) {
            this.projectOrderCertifiedCompletionDateFieldName = props.resources.CertifiedCompletionDateLabel;
        }
        else if (this.props.workflowsQA['117']) {
            try {
                this.projectOrderCertifiedDateField = this.props.workflowsQA['117'].placeholders.find(ph => ph.replacementKey === 'ProjectOrderCompletionFields')
                    .values.find(phItem => phItem.field === 'CertifiedDate');

                if (this.projectOrderCertifiedDateField?.isActive) {
                    this.projectOrderCertifiedCompletionDateFieldName = this.projectOrderCertifiedDateField.display;
                }
            } catch (error) {
                console.log('ProjectOrderCompletionFields placeholder not available!');
            }
        }

        this.paymentPeriods = paymentPeriods.map(p => (this.props.intl.formatMessage({ id: "GENERAL.FORMS." + p })));
        this.calculationPeriods = calculationPeriods.map(p => (this.props.intl.formatMessage({ id: "GENERAL.FORMS." + p })));
    }
    shouldComponentUpdate() {
        return false;
    }
    render() {
        const { workflowItem } = this.props;

        return (
            <>
                <Routes caseSensitive>
                    <Route
                        path={workflowItem.config.paths.list}
                        exact
                        element={<ProjectList
                            {...this.props}
                            paymentPeriods={this.paymentPeriods}
                            calculationPeriods={this.calculationPeriods}
                            title={this.notificationName}
                            abbreviation={this.abbreviation}
                            notificationType={this.notificationType}
                            CENProjectOrderOptionEnabled={this.CENProjectOrderOptionEnabled}
                            projectOrderCertifiedStartDateFieldName={this.projectOrderCertifiedStartDateFieldName}
                            projectOrderCertifiedCompletionDateFieldName={this.projectOrderCertifiedCompletionDateFieldName}

                        />}
                    />
                    <Route
                        path={workflowItem.config.paths.create}
                        exact
                        element={
                            workflowItem.userFilters.mainNotice.createAllowed ? (
                                <ProjectCreate
                                    {...this.props}
                                    paymentPeriods={this.paymentPeriods}
                                    calculationPeriods={this.calculationPeriods}
                                    notificationType={this.notificationType}
                                    title={this.notificationName}
                                />) : (
                                <Navigate replace to={workflowItem.paths.defaultPath} />
                            )
                        }
                    />
                    <Route
                        path={'/:notificationid/*'}
                        exact
                        element={<ProjectDetail
                            {...this.props}
                            paymentPeriods={this.paymentPeriods}
                            calculationPeriods={this.calculationPeriods}
                            title={this.notificationName}
                            abbreviation={this.abbreviation}
                            documentType={this.documentType}
                            notificationType={this.notificationType}
                            poNotificationName={this.poNotificationName}
                            itqNotificationName={this.itqNotificationName}

                        />}
                    />
                </Routes>
            </>
        );
    }
}

export default injectIntl(ProjectPmRouter);